import { inject } from 'vue';

interface Globals {
  $trlMessage: (
    message: string,
    payload?: Record<string, unknown>,
    defaultValue?: string
  ) => string;
}

export function useGlobal(): Globals {
  const $trlMessage = inject<Globals['$trlMessage']>('$trlMessage');
  if (!$trlMessage) {
    throw new Error('$trlMessage не зарегестрирован');
  }
  return {
    $trlMessage
  };
}
